import {
  stat
} from "fs";

const siteInfo = {
  state: {
    data: null
  },
  mutations: {
    SET_SITEINFO: (state, siteInfo) => {
      state.data = siteInfo
    }
  }
}

export default siteInfo


// WEBPACK FOOTER //
// ./src/store/modules/siteInfo.js